export const products = {
      title: 'Products',
      subtitle: 'Manage the simple product catalog.',
      recordsTitle: 'Product records',
      recordsDescription: 'Catalog to manage products without costing or demo data.',
      createTitle: 'Add product',
      editTitle: 'Edit product',
      createSubtitle: 'Capture the main product details.',
      editSubtitle: 'Update the main product details.',
      isActiveLabel: 'Active product',
      isActiveHint: 'Turn this off if the product should no longer appear as an operational option.',
      packagingTypesLabel: 'Packaging types',
      defaultPackagingTypeOption: 'Mark as default',
      packagingTypesEmpty: 'There are no packaging types available.',
      deleteTitle: 'Delete product',
      deleteSubtitle: 'This action will delete product {{name}}.',
      deleteSubtitleFallback: 'This action will delete the selected product.',
      emptyTitle: 'No products available',
      emptyDescription: 'There are no registered products yet.',
    } as const;
